import { Info } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';

export function LotSizingCurrentDataIndicator() {
  const { t } = useTranslation('lotSizing');

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          aria-label={t('currentDataLabel')}
          className='inline-flex size-5 shrink-0 items-center justify-center rounded-full text-muted-foreground hover:bg-accent hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring'
          type='button'
        >
          <Info aria-hidden='true' className='size-3.5' />
        </button>
      </TooltipTrigger>
      <TooltipContent className='max-w-64' sideOffset={5}>
        {t('currentDataTooltip')}
      </TooltipContent>
    </Tooltip>
  );
}
